import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { PermissionsEnum } from '@/auth/interfaces';
import { newSolicitudClienteCorporativo, ROUTER_PATHS, useCheckPermissions  } from '@/shared';
import {
    SingleFormBoxScene,
} from '@/shared/components/ui';
import { usePostSolicitudCorporativa } from '@/shared/actions/erp/solicitudpreventacoorporativo/solicitur-preventa-corporativo.actions'

import { ClienteSucursal } from '.';



const SaveSolicitudPreventa: React.FC<any> = ({ titlePage }) => {
  useCheckPermissions(PermissionsEnum.api_add_solicitudcorporativa);
  const navigate = useNavigate();
  const returnUrl = ROUTER_PATHS.solicitud_preventa.solicitudNav;

  // Un solo cliente por solicitud (no se agregan/eliminan clientes).
  const form = useForm({
    resolver: yupResolver(newSolicitudClienteCorporativo) as any,
    defaultValues: {
      clientes: [
        {
          cliente_oficina: '',
          ciudad: '',
          direccion: '',
          contacto_sitio: '',
          telefono: '',
          sucursales: [
            {
              nombre_sucursal: '',
              velocidad: 0,
              servicio: '',
              coordenadas: '',
            },
          ],
        },
      ],
    },
  });

  const { control, handleSubmit, formState: {errors}} = form;

  const createMutation = usePostSolicitudCorporativa({
    navigate,
    returnUrl,
  });

  const onSave = (data: any) => {
    createMutation.mutate(data);
  };

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => navigate(returnUrl)}
      onSave={handleSubmit(onSave)}
    >
      {/* CLIENTE ÚNICO */}
      <ClienteSucursal
        control={control}
        clienteIndex={0}
        errores={errors}
      />
    </SingleFormBoxScene>
  );
};

export default SaveSolicitudPreventa;